/** Service-level booking_policy JSON (v2) — server resolve_booking_offer + RPC pricing use these keys. */

export type BookingPolicyV2 = {
  version?: number;
  instant?: { enabled?: boolean; min_notice_hours?: number };
  request?: { enabled?: boolean; min_notice_hours?: number; vendor_response_sla_minutes?: number };
  urgent?: {
    enabled?: boolean;
    min_notice_hours?: number;
    max_notice_hours?: number;
    vendor_response_sla_minutes?: number;
    pricing_strategy?: string;
    pricing_value?: number;
  };
  same_day?: { bookings_must_be_before_local_time?: string; timezone?: string };
  slot_occupancy_model?: string;
  auto_refund_on_decline?: boolean;
  auto_refund_on_timeout?: boolean;
};

export const DEFAULT_BOOKING_POLICY_V2: BookingPolicyV2 = {
  version: 2,
  instant: { enabled: true, min_notice_hours: 48 },
  request: { enabled: true, min_notice_hours: 24, vendor_response_sla_minutes: 30 },
  urgent: {
    enabled: true,
    min_notice_hours: 12,
    max_notice_hours: 24,
    vendor_response_sla_minutes: 60,
    pricing_strategy: "multiplier",
    pricing_value: 1.5,
  },
  same_day: { bookings_must_be_before_local_time: "08:00", timezone: "Europe/Rome" },
  slot_occupancy_model: "vendor_capacity",
  auto_refund_on_decline: true,
  auto_refund_on_timeout: true,
};

export function mergeBookingPolicy(raw: unknown): BookingPolicyV2 {
  const d = DEFAULT_BOOKING_POLICY_V2;
  if (!raw || typeof raw !== "object") return { ...d };
  const r = raw as Record<string, unknown>;
  return {
    ...d,
    ...r,
    instant: { ...d.instant, ...(typeof r.instant === "object" && r.instant ? (r.instant as object) : {}) },
    request: { ...d.request, ...(typeof r.request === "object" && r.request ? (r.request as object) : {}) },
    urgent: { ...d.urgent, ...(typeof r.urgent === "object" && r.urgent ? (r.urgent as object) : {}) },
    same_day: { ...d.same_day, ...(typeof r.same_day === "object" && r.same_day ? (r.same_day as object) : {}) },
  };
}
